// @flow
import * as React from 'react'
import * as R from 'ramda'

import { withState } from 'recompose'
import { Grid } from 'semantic-ui-react'
import { thumbnailUrl } from '../../../../../../../shared/utils/URLs'

import FlyerCard from './FlyerCard'

let styles = {}

const NUMBER_OF_ADDITIONAL_FLYERS_TO_LOAD = 4

type RecomposeProps = {|
  +updateNumberOfFlyersToDisplay: (count: number) => void,
  +numberOfFlyersToDisplay: number
|}

type OwnProps = {|
  +flyers: Array<any>, // TODO (quinkinser) no 'any' types
  +resource: string,
  +resourceId: string,
  +handleMetricClick: Function // TODO (quinkinser) no 'Function' types
|}

type Props = {|
  ...RecomposeProps,
  ...OwnProps
|}

const withToggleVisibility = withState(
  'isGroupVisible',
  'setGroupVisible',
  false
)
const FlyerGroup = withToggleVisibility(
  ({
    flyers,
    handleMetricClick,
    resource,
    resourceId,
    isGroupVisible,
    setGroupVisible
  }) => (
    <React.Fragment>
      {flyers.map(flyer => (
        <Grid.Column key={flyer.flyer_id} style={styles.flyerGridColumn}>
          <FlyerCard
            handleMetricClick={handleMetricClick}
            flyerId={flyer.flyer_id}
            flyerTitle={flyer.title}
            linkTo={`/flyers/${flyer.flyer_id}/${resource}/${resourceId}`}
            header={flyer.title}
            ocrText={
              flyer.pages && flyer.pages[0] ? flyer.pages[0].ocr_text : ''
            }
            category={flyer.category}
            senderEmail={flyer.seller_email}
            description={flyer.description}
            imageUrl={thumbnailUrl(flyer)}
            pageCount={flyer.page_count}
            isGroupVisible={isGroupVisible}
            // TODO (quinkinser) don't pass this function down, should only be
            // fired once per group. No arrow functions in render.
            setGroupVisible={() => {
              if (isGroupVisible === false) {
                setGroupVisible(true)
              }
            }}
          />
        </Grid.Column>
      ))}
    </React.Fragment>
  )
)

const FlyerCardList = ({
  flyers,
  resource,
  resourceId,
  handleMetricClick
}: Props) => (
  <Grid columns={4} doubling stackable padded>
    {R.splitEvery(NUMBER_OF_ADDITIONAL_FLYERS_TO_LOAD, flyers).map(
      flyerGroup => (
        <FlyerGroup
          flyers={flyerGroup}
          handleMetricClick={handleMetricClick}
          resource={resource}
          resourceId={resourceId}
          key={flyerGroup.length ? flyerGroup[0].flyerId : resourceId}
        />
      )
    )}
  </Grid>
)

styles = {
  flyerGridColumn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}

export default FlyerCardList



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/components/FlyerGridBody/components/FlyerCardList.js